import React from 'react';
import SportHotEvents from '../../hot-events/SportHotEvents';
import SportSidebarSoonCampaigns from './campaigns/SportSidebarSoonCampaigns';
import Wrapper from './styles';
import SportTreeMenu from '../../tree/menu/SportTreeMenu';
import SportSettingsMenuButton from '../../settings-menu/button/SportSettingsMenuButton';
import { isFeatureAvailable } from '../../../../services/feature';
import SportBonusBetList from '../../bonus-bet/list/SportBonusBetList';
import { FEATURE } from '../../../../services/types';
import SportLobbyCategoriesV2 from '../../lobby-categories-v-2/SportLobbyCategoriesV2';

export default function SportSidebarSoon() {
    const isLayoutB = !isFeatureAvailable(FEATURE.SPORT_LAYOUT_A);
    const isMainNavigationV2 = isFeatureAvailable(FEATURE.SPORT_MAIN_NAVIGATION_V2);

    return (
        <Wrapper>
            {!isLayoutB && (
                <>
                    {isMainNavigationV2 && <SportLobbyCategoriesV2 />}
                    <SportSettingsMenuButton />
                    <SportBonusBetList />
                    <SportSidebarSoonCampaigns />
                </>
            )}
            <SportHotEvents wrap type="menu" />
            <SportTreeMenu />
        </Wrapper>
    );
}
